import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const Aplicacion = () => {
  return ( 
      <App />
   );
}

ReactDOM.render(<Aplicacion />, document.getElementById('root'));
